import r from "./_baseGetTag.js";
import t from "./isObjectLike.js";
var s = r, a = t, b = "[object Arguments]";
function g(e) {
  return a(e) && s(e) == b;
}
var o = g;
export {
  o as default
};
//# sourceMappingURL=_baseIsArguments.js.map
